<template>
  <v-card class="elevation-1 rounded-lg mb-4 catalog-card-wrapper">
    <!-- Barra Superior / Header -->
    <v-toolbar color="secondary" dark dense flat height="auto" class="py-2 px-1 catalog-toolbar">
      <div class="d-flex align-center header-catalog-title-wrap">
        <v-icon left size="22" class="flex-shrink-0 mr-2">mdi-car-tire</v-icon>
        <span class="catalog-title font-weight-bold">
          {{
            tipo === "marca"
              ? "Catálogo de Marcas / Diseños Disponibles"
              : "Catálogo de Neumáticos Disponibles"
          }}
        </span>
      </div>
      <v-spacer class="d-none d-sm-block"></v-spacer>
      <div class="header-catalog-chip-wrap ml-auto ml-sm-0 mt-1 mt-sm-0">
        <v-chip small color="primary" class="font-weight-bold catalog-total-chip" outlined>
          Total:
          {{ ItemTotal != null ? ItemTotal : data ? data.length : 0 }}
          {{ tipo === "marca" ? "elementos" : "neumáticos" }}
        </v-chip>
      </div>
    </v-toolbar>

    <!-- Barra de Instrucciones y Selección Activa -->
    <div class="px-3 px-sm-4 pt-3 pb-1">
      <v-alert
        v-if="selectedItemObj"
        dense
        text
        color="primary"
        icon="mdi-check-circle"
        class="mb-2 selection-alert-active"
      >
        <div class="d-flex align-center justify-space-between flex-wrap">
          <div class="selection-alert-text">
            <span class="font-weight-medium text-caption text-sm-body-2">
              {{
                tipo === "marca"
                  ? "Marca / Diseño listo para ubicar:"
                  : "Neumático listo para ubicar:"
              }}
            </span>
            <strong class="primary--text text-subtitle-2 ml-1">
              {{
                tipo === "marca"
                  ? selectedItemObj.marca ||
                    selectedItemObj.disenio ||
                    selectedItemObj.descripcion ||
                    selectedItemObj.num_serie
                  : selectedItemObj.num_serie || selectedItemObj.descripcion
              }}
            </strong>
            <span
              v-if="tipo !== 'marca' && selectedItemObj.marca"
              class="grey--text text--darken-2 ml-1 text-caption"
            >
              ({{ selectedItemObj.marca }}
              {{ selectedItemObj.modelo ? "• " + selectedItemObj.modelo : "" }})
            </span>
            <span
              class="ml-sm-2 d-block d-sm-inline font-italic text-caption grey--text text--darken-3"
            >
              — Haga clic en una ranura vacía de la tabla inferior para posicionarlo.
            </span>
          </div>
          <v-btn
            x-small
            outlined
            color="primary"
            class="ml-auto mt-2 mt-sm-0"
            @click="cancelarSeleccion"
          >
            <v-icon x-small left>mdi-close</v-icon>
            Cancelar selección
          </v-btn>
        </div>
      </v-alert>

      <v-alert
        v-else
        dense
        text
        color="info"
        icon="mdi-cursor-default-click-outline"
        class="mb-2 step-instruction-alert"
      >
        <span class="step-instruction-text font-weight-medium">
          <strong>Paso 1:</strong> Seleccione un
          {{ tipo === "marca" ? "elemento" : "neumático" }} de las tarjetas.
          <strong>Paso 2:</strong> Haga clic en una ranura de la tabla comparativa para ubicarlo.
        </span>
      </v-alert>
    </div>

    <!-- Buscador -->
    <div class="px-4 pb-2">
      <v-row align="center" no-gutters>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
            v-model="search"
            @input="ActualizarListadoAgregado"
            append-icon="mdi-magnify"
            label="Buscar por serie o descripción..."
            single-line
            hide-details
            dense
            outlined
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <!-- Spinner de Carga -->
    <div
      v-if="loader"
      class="d-flex flex-column align-center justify-center py-10"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="48"
        width="4"
        class="mb-3"
      ></v-progress-circular>
      <span
        class="text-subtitle-2 grey--text text--darken-2 font-weight-medium"
      >
        Cargando
        {{ tipo === "marca" ? "elementos" : "neumáticos" }} disponibles...
      </span>
    </div>

    <!-- Iterador de Tarjetas de Neumáticos -->
    <div v-show="!loader">
      <v-data-iterator
        class="px-4 pb-2"
        :items="data || []"
        :items-per-page="Number(per_page)"
        :page="Number(page)"
        :footer-props="{
          'items-per-page-options': [6, 12, 18],
          'items-per-page-text': 'Resultados por página:',
          'page-text': `${from != null ? from : 0}-${to != null ? to : 0} de ${
            ItemTotal != null ? ItemTotal : 0
          }`,
          'disable-page-before': loader,
          disablePagination: loader,
          disableItemsPerPage: loader,
        }"
        @update:options="ActualizarListado"
        :server-items-length="ItemTotal"
      >
        <template v-slot:no-data>
          <div class="text-center py-8 grey--text text--darken-1">
            <v-icon size="48" color="grey lighten-1">mdi-car-tire-alert</v-icon>
            <div class="mt-2 text-subtitle-2 font-weight-medium">
              No se encontraron
              {{ tipo === "marca" ? "elementos" : "neumáticos" }} disponibles
              con los filtros aplicados.
            </div>
          </div>
        </template>

        <template v-slot:default="{ items }">
          <v-row class="catalog-grid-row justify-center justify-sm-start">
            <v-col
              v-for="(item, index) in items"
              :key="index"
              cols="10"
              sm="6"
              md="4"
              lg="2"
              class="d-flex justify-center"
            >
              <div
                class="neumatico-selector-card w-100"
                :class="{
                  'card-selected': isItemSelected(item),
                  'card-disabled': isItemInComparison(item),
                  'card-available':
                    !isItemSelected(item) && !isItemInComparison(item),
                }"
                @click="onCardClick(item)"
              >
                <!-- Badges Superiores -->
                <div
                  class="card-top-header d-flex justify-space-between align-center mb-1"
                >
                  <template v-if="tipo === 'marca'">
                    <span
                      v-if="item.nuevo !== undefined && item.nuevo !== null"
                      class="condicion-tag"
                      :class="getCondicionClass(item)"
                    >
                      {{
                        item.nuevo == "1" || item.nuevo == 1
                          ? "Nuevo"
                          : item.nuevo_reenc || "Reencauche"
                      }}
                    </span>
                    <span
                      v-else-if="item.marca || item.disenio"
                      class="condicion-tag condicion-nuevo"
                    >
                      {{ item.marca ? "Marca" : "Diseño" }}
                    </span>
                    <span v-else class="condicion-tag condicion-nuevo">
                      Disponible
                    </span>
                  </template>
                  <template v-else>
                    <span
                      class="condicion-tag"
                      :class="getCondicionClass(item)"
                    >
                      {{
                        item.nuevo == "1" || item.nuevo == 1
                          ? "Nuevo"
                          : item.nuevo_reenc || "Reencauche"
                      }}
                    </span>
                  </template>

                  <span
                    v-if="isItemInComparison(item)"
                    class="status-tag status-in-table"
                  >
                    <v-icon x-small color="grey darken-2">mdi-check</v-icon> En
                    tabla
                  </span>
                  <span
                    v-else-if="isItemSelected(item)"
                    class="status-tag status-active"
                  >
                    <v-icon x-small color="white">mdi-check-bold</v-icon> Listo
                  </span>
                  <span v-else class="status-tag status-ready">
                    Disponible
                  </span>
                </div>

                <!-- Gráfico de Neumático -->
                <div class="tire-visual-container py-2">
                  <img
                    :src="imagen"
                    alt="neumatico"
                    class="tire-visual-img"
                    :class="{
                      'img-selected': isItemSelected(item),
                      'img-disabled': isItemInComparison(item),
                    }"
                  />
                </div>

                <!-- Información Principal -->
                <div class="tire-card-body text-center">
                  <template v-if="tipo === 'marca'">
                    <div class="tire-serial-badge text-truncate">
                      {{
                        item.marca ||
                        item.disenio ||
                        item.descripcion ||
                        item.num_serie
                      }}
                    </div>
                    <div
                      v-if="item.modelo"
                      class="tire-brand-model text-truncate"
                    >
                      {{ item.modelo }}
                    </div>
                    <div
                      v-if="item.medida"
                      class="tire-dimension text-truncate"
                    >
                      {{ item.medida }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="tire-serial-badge text-truncate">
                      {{ item.num_serie || item.descripcion }}
                    </div>
                    <div class="tire-brand-model text-truncate">
                      {{ item.marca || "" }}
                      {{ item.modelo ? "• " + item.modelo : "" }}
                    </div>
                    <div
                      v-if="item.medida"
                      class="tire-dimension text-truncate"
                    >
                      {{ item.medida }}
                    </div>
                  </template>
                </div>

                <!-- Botón / Indicador Inferior -->
                <div class="tire-card-footer mt-2">
                  <div
                    v-if="isItemInComparison(item)"
                    class="footer-btn footer-disabled"
                  >
                    <v-icon x-small color="grey darken-1" class="mr-1"
                      >mdi-lock-outline</v-icon
                    >
                    <span>Ya ubicado</span>
                  </div>
                  <div
                    v-else-if="isItemSelected(item)"
                    class="footer-btn footer-selected"
                  >
                    <v-icon x-small color="white" class="mr-1"
                      >mdi-arrow-down-bold-circle</v-icon
                    >
                    <span>Clic en tabla abajo</span>
                  </div>
                  <div v-else class="footer-btn footer-available">
                    <v-icon x-small color="primary" class="mr-1"
                      >mdi-cursor-pointer</v-icon
                    >
                    <span>Seleccionar</span>
                  </div>
                </div>

                <!-- Tooltip Descriptivo al Hover -->
                <Description
                  v-if="VerTooltip == true"
                  class="tooltiptext"
                  :title="titulo(item.estado)"
                  :subtitle="subtitulo(item.estado)"
                  :item="item"
                ></Description>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </div>
  </v-card>
</template>

<script>
import Description from "./instalacionneumaticos/description.vue";

export default {
  components: {
    Description,
  },
  props: {
    tipo: {
      type: String,
      default: "configuracion",
    },
    Items: [Array, Object],
    data: Array,
    from: [Number, String],
    to: [Number, String],
    ItemTotal: [Number, String],
    loader: Boolean,
    per_page: [Number, String],
    page: [Number, String],
    VerTooltip: Boolean,
    dato_seleccionado: {
      type: Array,
      default: () => [],
    },
    seleccionados: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["getListado", "seleccionarNeumatico"],
  data() {
    return {
      imagen: "images/llanta.png",
      search: "",
      pageLocal: Number(this.page) || 1,
      perPageLocal: Number(this.per_page) || 6,
      sortByLocal: "id",
      sortDescLocal: "DESC",
    };
  },
  computed: {
    selectedItemObj() {
      if (this.dato_seleccionado && this.dato_seleccionado.length > 0) {
        return this.dato_seleccionado[0];
      }
      return null;
    },
  },
  methods: {
    isItemSelected(item) {
      if (
        !item ||
        !this.dato_seleccionado ||
        this.dato_seleccionado.length === 0
      )
        return false;
      return this.dato_seleccionado.some((d) => {
        if (!d) return false;
        if (d === item) return true;

        if (this.tipo === "marca") {
          // Si ambos tienen diseño o id_disenio (modo reencauche/diseño)
          if (
            d.id_disenio != null &&
            item.id_disenio != null &&
            String(d.id_disenio) === String(item.id_disenio)
          )
            return true;
          if (d.disenio && item.disenio && d.disenio === item.disenio)
            return true;

          // Si ambos tienen marca o id_marca
          if (
            d.id_marca != null &&
            item.id_marca != null &&
            String(d.id_marca) === String(item.id_marca)
          )
            return true;

          // Si tienen id general
          if (
            d.id != null &&
            item.id != null &&
            d.id !== "" &&
            String(d.id) === String(item.id)
          )
            return true;

          // Comparación por marca sólo si ninguno es un diseño
          if (
            !d.disenio &&
            !item.disenio &&
            !d.id_disenio &&
            !item.id_disenio &&
            d.marca &&
            item.marca &&
            d.marca === item.marca
          )
            return true;

          if (
            !d.disenio &&
            !item.disenio &&
            !d.id_disenio &&
            !item.id_disenio &&
            d.descripcion &&
            item.descripcion &&
            d.descripcion === item.descripcion
          )
            return true;
        } else {
          // Modo configuracion: comparación estrictamente por id o num_serie
          if (
            d.id != null &&
            item.id != null &&
            d.id !== "" &&
            String(d.id) === String(item.id)
          )
            return true;
          if (d.num_serie && item.num_serie && d.num_serie === item.num_serie)
            return true;
        }
        return false;
      });
    },
    isItemInComparison(item) {
      if (!item || !this.seleccionados || this.seleccionados.length === 0)
        return false;
      return this.seleccionados.some((s) => {
        if (!s) return false;
        if (s === item) return true;

        if (this.tipo === "marca") {
          if (typeof s === "object") {
            if (
              s.id_disenio != null &&
              item.id_disenio != null &&
              String(s.id_disenio) === String(item.id_disenio)
            )
              return true;
            if (s.disenio && item.disenio && s.disenio === item.disenio)
              return true;
            if (
              s.id_marca != null &&
              item.id_marca != null &&
              String(s.id_marca) === String(item.id_marca)
            )
              return true;
            if (
              s.id != null &&
              item.id != null &&
              s.id !== "" &&
              String(s.id) === String(item.id)
            )
              return true;
            if (
              !s.disenio &&
              !item.disenio &&
              !s.id_disenio &&
              !item.id_disenio &&
              s.marca &&
              item.marca &&
              s.marca === item.marca
            )
              return true;
            if (
              !s.disenio &&
              !item.disenio &&
              !s.id_disenio &&
              !item.id_disenio &&
              s.descripcion &&
              item.descripcion &&
              s.descripcion === item.descripcion
            )
              return true;
          } else {
            const strVal = String(s);
            if (item.id != null && String(item.id) === strVal) return true;
            if (item.id_disenio != null && String(item.id_disenio) === strVal)
              return true;
            if (item.id_marca != null && String(item.id_marca) === strVal)
              return true;
            if (item.disenio && item.disenio === strVal) return true;
            if (
              !item.disenio &&
              !item.id_disenio &&
              item.marca &&
              item.marca === strVal
            )
              return true;
            if (
              !item.disenio &&
              !item.id_disenio &&
              item.descripcion &&
              item.descripcion === strVal
            )
              return true;
          }
        } else {
          // Modo configuracion: comparación estrictamente por id o num_serie
          if (typeof s === "object") {
            if (
              s.id != null &&
              item.id != null &&
              s.id !== "" &&
              String(s.id) === String(item.id)
            )
              return true;
            if (s.num_serie && item.num_serie && s.num_serie === item.num_serie)
              return true;
          } else {
            const strVal = String(s);
            if (item.id != null && String(item.id) === strVal) return true;
            if (item.num_serie && item.num_serie === strVal) return true;
          }
        }
        return false;
      });
    },
    getCondicionClass(item) {
      if (item.nuevo == "1" || item.nuevo == 1) {
        return "condicion-nuevo";
      }
      return "condicion-reencauche";
    },
    onCardClick(item) {
      if (this.isItemInComparison(item)) return;
      this.seleccionarNeumatico(item);
    },
    seleccionarNeumatico(item) {
      this.$emit("seleccionarNeumatico", item);
    },
    cancelarSeleccion() {
      this.$emit("seleccionarNeumatico", null);
    },
    titulo(estado) {
      if (estado == 1) return "Listo para instalar";
      if (estado == 2) return "En reparación";
      if (estado == 3) return "Instalado";
      if (estado == 4) return "En reencauche";
      if (estado == 5) return "Listo para instalar";
      return "";
    },
    subtitulo(estado) {
      if (estado == 2) return "Registre el costo de reparación";
      if (estado == 4) return "Registre el costo de reencauche";
      return "";
    },
    ActualizarListado({ page, itemsPerPage, sortBy, sortDesc }) {
      this.pageLocal = page ? page : 1;
      this.perPageLocal = itemsPerPage ? itemsPerPage : 6;
      this.sortByLocal =
        sortBy && sortBy.length != 0 ? sortBy[0] : "created_at";
      this.sortDescLocal =
        sortDesc && sortDesc.length == 0
          ? "DESC"
          : sortDesc && sortDesc[0]
          ? "ASC"
          : "DESC";
      this.$emit("getListado", {
        page: page ? page : 1,
        per_page: itemsPerPage ? itemsPerPage : 6,
        search: this.search,
        sortBy: this.sortByLocal,
        sortDirection: this.sortDescLocal,
      });
    },
    ActualizarListadoAgregado() {
      this.$emit("getListado", {
        page: this.pageLocal ? this.pageLocal : 1,
        per_page: this.perPageLocal ? this.perPageLocal : 6,
        search: this.search,
        sortBy: this.sortByLocal ? this.sortByLocal : "created_at",
        sortDirection: this.sortDescLocal ? this.sortDescLocal : "DESC",
      });
    },
  },
};
</script>

<style scoped>
.catalog-card-wrapper {
  border: 1px solid #e2e8f0;
  overflow: visible;
}

.selection-alert-active {
  border-left: 4px solid #2563eb !important;
  background-color: #eff6ff !important;
  animation: pulse-border 2s infinite;
}

@keyframes pulse-border {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.3);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(37, 99, 235, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
  }
}

.neumatico-selector-card {
  border-radius: 12px;
  padding: 10px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 190px;
}

/* Disponible */
.card-available {
  border: 1.5px solid #e2e8f0;
  cursor: pointer;
}

.card-available:hover {
  border-color: #3b82f6;
  transform: translateY(-4px);
  box-shadow: 0 10px 20px -5px rgba(59, 130, 246, 0.15),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.card-available:hover .tire-visual-img {
  transform: scale(1.08);
}

/* Seleccionado */
.card-selected {
  border: 2px solid #2563eb !important;
  background: #f0f7ff !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2),
    0 8px 16px rgba(37, 99, 235, 0.12);
  transform: translateY(-3px);
  cursor: pointer;
}

.card-selected .tire-visual-img {
  transform: scale(1.1);
  filter: drop-shadow(0 4px 8px rgba(37, 99, 235, 0.25));
}

/* En comparación / Deshabilitado */
.card-disabled {
  border: 1.5px dashed #cbd5e1;
  background: #f8fafc;
  opacity: 0.65;
  cursor: not-allowed;
}

/* Badges de condición */
.condicion-tag {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.condicion-nuevo {
  background-color: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

.condicion-reencauche {
  background-color: #f5f3ff;
  color: #6d28d9;
  border: 1px solid #ddd6fe;
}

/* Status tags */
.status-tag {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 6px;
}

.status-ready {
  background: #f1f5f9;
  color: #64748b;
}

.status-active {
  background: #2563eb;
  color: #ffffff;
}

.status-in-table {
  background: #e2e8f0;
  color: #475569;
}

/* Gráfico */
.tire-visual-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 65px;
}

.tire-visual-img {
  max-width: 58px;
  max-height: 58px;
  object-fit: contain;
  transition: transform 0.22s ease, filter 0.22s ease;
}

.img-disabled {
  opacity: 0.45;
  filter: grayscale(100%);
}

/* Info */
.tire-serial-badge {
  font-size: 12.5px;
  font-weight: 800;
  color: #1e293b;
  letter-spacing: 0.2px;
}

.tire-brand-model {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

.tire-dimension {
  font-size: 10.5px;
  color: #94a3b8;
}

/* Footer buttons */
.footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 10.5px;
  font-weight: 600;
  transition: background-color 0.15s ease;
}

.footer-available {
  background: #f1f5f9;
  color: #2563eb;
}

.card-available:hover .footer-available {
  background: #e0e7ff;
  color: #1d4ed8;
}

.footer-selected {
  background: #2563eb;
  color: #ffffff;
}

.footer-disabled {
  background: #e2e8f0;
  color: #64748b;
}

/* Tooltip */
.neumatico-selector-card .tooltiptext {
  visibility: hidden;
  position: absolute;
  z-index: 1000;
  bottom: 102%;
  left: 50%;
  transform: translateX(-50%);
  width: 170px;
  background-color: #1e293b;
  color: #ffffff;
  border-radius: 8px;
  padding: 8px 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.neumatico-selector-card:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(-4px);
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
.catalog-title {
  font-size: 0.95rem;
  letter-spacing: 0.2px;
  line-height: 1.25;
}

.step-instruction-text {
  font-size: 0.815rem;
  line-height: 1.35;
}

@media (max-width: 600px) {
  .catalog-toolbar {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
    min-height: auto !important;
  }

  .catalog-toolbar ::v-deep .v-toolbar__content {
    flex-direction: column !important;
    align-items: flex-start !important;
    height: auto !important;
    padding: 0 4px !important;
  }

  .header-catalog-title-wrap {
    width: 100%;
  }

  .catalog-title {
    font-size: 0.85rem !important;
    white-space: normal;
    line-height: 1.25;
  }

  .header-catalog-chip-wrap {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-top: 6px !important;
  }

  .catalog-total-chip {
    font-size: 11px !important;
    height: 24px !important;
  }

  .step-instruction-alert {
    padding: 8px 12px !important;
  }

  .step-instruction-text {
    font-size: 0.76rem !important;
    line-height: 1.35;
    display: inline-block;
  }

  .selection-alert-text {
    width: 100%;
  }

  .condicion-tag,
  .status-tag {
    font-size: 9px !important;
    padding: 1.5px 5px !important;
  }

  .neumatico-selector-card {
    max-width: 270px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
